"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../../../IconicDisplayElements/Icon"));

var _Callout = require("./Callout.styles");

var _iconNames = _interopRequireDefault(require("../../../../constants/iconNames"));

var _text = require("../../../../styles/2_commonComponentStyles/text");

var _propTypes2 = _interopRequireDefault(require("../../../../constants/propTypes"));

var _ParagraphText = _interopRequireDefault(require("../../BasicTextElements/ParagraphText"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Our Callout component is usually used to bring the user's attention to an important item.
 */
// intentionally left as a functional component
var Callout = function Callout(_ref) {
  var children = _ref.children,
      className = _ref.className,
      colorTheme = _ref.colorTheme,
      dataTestId = _ref.dataTestId,
      iconName = _ref.iconName,
      textColorTheme = _ref.textColorTheme,
      props = _objectWithoutProperties(_ref, ["children", "className", "colorTheme", "dataTestId", "iconName", "textColorTheme"]);

  return /*#__PURE__*/_react.default.createElement(_Callout.StyledCallout, _extends({}, props, {
    className: className,
    "data-test-id": dataTestId
  }), /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: "c-callout-icon",
    colorTheme: colorTheme,
    dataTestId: "callout-icon",
    iconName: iconName
  }), /*#__PURE__*/_react.default.createElement(_ParagraphText.default, {
    colorTheme: textColorTheme,
    className: "c-callout-paragraph-text",
    dataTestId: "callout-paragraph-text"
  }, children));
};

Callout.propTypes = {
  /** Any valid HTML nodes or React components - though typical use is text */
  children: _propTypes2.default.children.isRequired,

  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Used to pick the color theme to apply to the icon - One of:
   * undefined,
   'primary',
   'tertiary',
   'cta',
   'overDark',
   */
  colorTheme: _propTypes.default.oneOf(_text.textThemes),

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Reflects string name of fontawesome icon - see 'constants/iconNames' for the full list */
  iconName: _propTypes.default.oneOf(_iconNames.default).isRequired,

  /** Used to pick the color theme to apply to the text - One of:
   * undefined,
   'primary',
   'tertiary',
   'cta',
   'overDark',
   */
  textColorTheme: _propTypes.default.oneOf(_text.textThemes)
};
Callout.defaultProps = {
  className: '',
  colorTheme: 'primary',
  textColorTheme: undefined
};
var _default = Callout;
exports.default = _default;